const CONTRAST_KEY = 'isHighContrast'
const FONT_SIZE_KEY = 'fontSize'
const PREFERRED_LANGUAGE_KEY = 'preferredLanguage'

export const getFontSize = () =>
  Number(window.localStorage.getItem(FONT_SIZE_KEY)) || 0

export const setFontSize = (val: number) =>
  window.localStorage.setItem(FONT_SIZE_KEY, `${val}`)

export const getIsHighContrast = () =>
  window.localStorage.getItem(CONTRAST_KEY) === 'true'

export const setIsHighContrast = (val: boolean) =>
  window.localStorage.setItem(CONTRAST_KEY, `${val}`)

export const getPreferredLanguage = () =>
  window.localStorage.getItem(PREFERRED_LANGUAGE_KEY)

export const setPreferredLanguage = (val: string) => {
  window.localStorage.setItem(PREFERRED_LANGUAGE_KEY, val)
}
